import React, { useState, useEffect } from "react";
import "./NbfcPage.css";
import BASE_URL from "../apiConfig";
import useRecaptcha from "../hooks/useRecaptcha";
import technopark from "../images/technopark.jpg";
import lendingImg from "../images/loan.jpg";
import riskImg from "../images/analytics.jpg";
import digitalImg from "../images/mobile.jpg";
import recoveryImg from "../images/collection.jpg";
import investorImg from "../images/inventory.jpg";
import complianceImg from "../images/reporting.jpg";

function NbfcPage() {
  const [widgetId, setWidgetId] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { getResponse } = useRecaptcha();

  useEffect(() => {
    if (window.grecaptcha) {
      const container = document.getElementById("recaptcha-nbfc");
      if (container && container.innerHTML === "") {
        try {
          const id = window.grecaptcha.render(container, {
            // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
             sitekey: window.RECAPTCHA_SITE_KEY,
          });
          setWidgetId(id);
        } catch (err) {
          console.error("reCAPTCHA NbfcPage render error:", err);
        }
      }
    }
  }, []);

  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    email: "",
    organization: "",
    challenges: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.full_name || !formData.phone) {
      setMessage("❌ Name & Phone required");
      return;
    }

    setLoading(true);

    try {
      const token = getResponse(widgetId);
      if (!token) {
        setMessage("❌ Please complete the reCAPTCHA");
        setLoading(false);
        return;
      }

      const fd = new FormData();
      Object.keys(formData).forEach(k => {
        fd.append(k, formData[k]);
      });
      fd.append("_type", "nbfc_demo");
      fd.append("tk", token);

      const res = await fetch(
        BASE_URL + "/DemoApi/saveData",
        { method: "POST", body: fd }
      );

      const result = await res.json();

      if (result.status) {
        setMessage("✅ Demo Request Submitted");
        setFormData({
          full_name: "",
          phone: "",
          email: "",
          organization: "",
          challenges: ""
        });
      } else {
        setMessage("❌ " + (result.message || "Verification Failed"));
      }

    } catch (err) {
      console.error("Submission Error:", err);
      setMessage("❌ Submission Failed. Check Console.");
    }

    setLoading(false);
  };

  const sections = [
    {
      title: "Core Lending & Loan Management",
      image: lendingImg,
      points: [
        "Multi-Product Loan Origination – Gold loans, business loans, personal loans, MSME loans, vehicle finance",
        "Configurable Loan Schemes – Create unlimited product variants",
        "Automated Credit Underwriting",
        "Maker-Checker Workflows",
        "Collateral Management – Gold, property, vehicle tracking"
      ]
    },
    {
      title: "Portfolio & Risk Management",
      image: riskImg,
      points: [
        "Real-Time Portfolio Dashboard",
        "Automated NPA Classification",
        "Early Warning System (EWS)",
        "Risk-Based Pricing",
        "Provisioning Automation"
      ]
    },
    {
      title: "Digital & Mobile Capabilities",
      image: digitalImg,
      points: [
        "Mobile Loan Origination System (LOS)",
        "Customer Mobile App",
        "WhatsApp Integration",
        "Video KYC & eSign"
      ]
    },
    {
      title: "Recovery & Collections",
      image: recoveryImg,
      points: [
        "Collections Dashboard",
        "Automated Follow-up System",
        "Promise-to-Pay Tracking",
        "Legal & SARFAESI Module",
        "Field Collection App"
      ]
    },
    {
      title: "Investor & Financial Management",
      image: investorImg,
      points: [
        // "Investor Reporting Portal",
        "Debit and NCD management",
        // "Co-Lending & PSL Management",
        "Capital Adequacy Monitoring",
        "Securitization Support"
      ]
    },
    {
      title: "Compliance & Reporting",
      image: complianceImg,
      points: [
        "Automated Regulatory Returns",
        "Audit Trail & Logs",
        "GST & TDS Automation",
        // "Data Export to CICs"
      ]
    }
  ];

  return (
    <>
      {/* HERO SECTION */}
      <div
        className="bg-container-nbfc"
        style={{ backgroundImage: `url(${technopark})` }}
      ></div>

      <div className="nbfc-wrapper">
        <div className="nbfc-left">
          <h1>IGNOSI - BANQ</h1>
          <h2>Agile Lending with End-to-End Control</h2>
          <h3>From lead origination to AI-driven recovery—manage loan lifecycles.</h3>

          <p>
            From lead origination via mobile apps to AI-driven recovery—manage loan lifecycles, investor reporting, capital adequacy and compliance seamlessly. Manage loan lifecycles, investor reporting, capital adequacy and compliance seamlessly.
          </p>

          <ul>
            <li>End-to-End Loan Lifecycle</li>
            <li>Risk & Portfolio Intelligence</li>
            <li>Investor & Compliance Ready</li>
            <li>Digital Lending Platform</li>
          </ul>
        </div>

        <div className="nbfc-right">
          <form className="demo-form-nbfc" onSubmit={handleSubmit}>
            <input
              name="full_name"
              placeholder="Full Name*"
              value={formData.full_name}
              onChange={handleChange}
            />

            <input
              name="phone"
              placeholder="Phone Number*"
              value={formData.phone}
              onChange={handleChange}
            />

            <input
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
            />

            <input
              name="organization"
              placeholder="NBFC Name"
              value={formData.organization}
              onChange={handleChange}
            />

            <textarea
              name="challenges"
              placeholder="What challenges are you looking to solve?"
              value={formData.challenges}
              onChange={handleChange}
            />

            <div
              id="recaptcha-nbfc"
              style={{ marginBottom: "15px" }}
            ></div>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Book a Demo"}
            </button>

            {message && <p className="form-msg-nbfc">{message}</p>}
          </form>
        </div>
      </div>

      {/* PLATFORM INTRO */}
      <div className="nbfc-intro-section">
        <h2>NBFC Software Solution</h2>
        <p>End-to-End Digital Lending Platform for NBFCs with IGNOSI.</p>
      </div>

      {/* FEATURE SECTIONS */}
      <div className="nbfc-features-section">
        {sections.map((sec, i) => (
          <div
            key={i}
            className={`nbfc-feature-row ${i % 2 !== 0 ? "feature-reverse" : ""}`}
          >
            <div className="nbfc-feature-img">
              <img src={sec.image} alt={sec.title} />
            </div>

            <div className="nbfc-feature-content">
              <h3>{sec.title}</h3>
              <ul>
                {sec.points.map((p, index) => (
                  <li key={index}>{p}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* ADVANCED FEATURES */}
      <div className="nbfc-advanced-section">
        <h2 className="advanced-title-nbfc">Advanced Features</h2>
        <div className="advanced-grid-nbfc">
          {[
            { title: "Bulk Disbursement", desc: "UPI, NEFT, RTGS integration for mass payouts" },
            { title: "Dynamic Checklist", desc: "Product-wise mandatory document collection" },
            { title: "API Banking", desc: "Connect with banks, payment gateways and bureaus" },
            { title: "Fraud Detection", desc: "Duplicate KYC, fake document and identity theft alerts" }
          ].map((item, idx) => (
            <div key={idx} className="advanced-card-nbfc">
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* BUSINESS INTELLIGENCE */}
      <div className="nbfc-bi-section modern-bi-flow bi-flow-compact">

        <h2 className="bi-title-modern">
          Business Intelligence
        </h2>

        <div className="bi-flow-wrapper">

          {[
            "Branch & Staff Performance Reports – Disbursement, recovery and profitability metrics",
            "Customer Behavior Analytics – Repayment patterns and cross-sell opportunities",
            "Liquidity Management Dashboard – Cash flow forecasting and fund deployment",
            "Yield & Spread Analysis – Product-wise profitability reports"
          ].map((item, idx) => (
            <div key={idx} className="bi-flow-item">
              <div className="bi-dot"></div>
              <p>{item}</p>
            </div>
          ))}

        </div>

      </div>
    </>
  );
}

export default NbfcPage;